import { Injectable } from '@angular/core';
import {Subject} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class UIService {
  error$ = new Subject<any>();
  constructor() { }
}
